import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAngularuniversalComponent } from './simple-icons-angularuniversal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAngularuniversalComponent ],
    exports:      [ SimpleIconsAngularuniversalComponent ],
    bootstrap:    []
})
export class SimpleIconsAngularuniversalModule {}
